// extracted by mini-css-extract-plugin
export default {"container":"doughnut-chat_container__mrZEZ","itemColor":"doughnut-chat_itemColor__ehMAt"};